import { useState } from "react";
import { PaperPlaneTilt, Sparkle } from "@phosphor-icons/react";

export default function CopilotInput({ disabled, activeSessionId, onSend }) {
  const [input, setInput] = useState("");

  const submit = () => {
    const text = input.trim();
    if (!text || disabled) return;
    onSend(text);
    setInput("");
  };

  return (
    <div className="border-t border-zinc-950 p-3">
      <div className="flex items-center gap-2 border border-zinc-300 focus-within:border-zinc-950 px-3 py-2 transition-colors">
        <Sparkle size={14} className="text-zinc-400" />
        <input
          data-testid="copilot-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && submit()}
          placeholder="Ask about finance, HR, supply chain…"
          className="flex-1 text-sm bg-transparent outline-none placeholder:text-zinc-400"
          disabled={disabled}
        />
        <button
          data-testid="copilot-send-btn"
          onClick={submit}
          disabled={!input.trim() || disabled}
          className="text-zinc-950 disabled:text-zinc-300 hover:text-[#FF3E00] transition-colors"
        >
          <PaperPlaneTilt size={16} weight="fill" />
        </button>
      </div>
      <div className="font-mono text-[9px] tracking-[0.15em] text-zinc-400 mt-1.5">
        CLAUDE SONNET 4.5 · {activeSessionId ? `SESSION ${activeSessionId.slice(0, 14)}…` : "NEW SESSION"}
      </div>
    </div>
  );
}
